import moment from 'moment';
import React from 'react'
import ReactDatePicker from 'react-datepicker';
import { Col, Label, Row } from 'reactstrap';
import { WhiteDeleteIcon } from '../../../assets/images';
import { CalenderIcon, DeleteIcon } from '../../Icon';
import { PaymentDetailsType } from './AddEditDisbursementForm'
type AppProps = {
    paymentDetailsData: PaymentDetailsType[];
    handlePaymentDetailsChange: (dataKey: any, value: any, index: number) => void;
    handleRemoveRow: (data: number) => void;
}
const DisbursementPaymentDetails = ({
    paymentDetailsData,
    handlePaymentDetailsChange,
    handleRemoveRow
}: AppProps) => {
    const prevent=(e:any)=>{
        document.addEventListener('keypress', function (e) {
            if (e.keyCode === 13 || e.which === 13) {
              e.preventDefault();
              return false;
            }
          });
    }
    const renderPaymentDetails = () => {
        let arr: any[] = [];
        paymentDetailsData?.map((item: any, i: number) => {
            if (item?.hasOwnProperty("amountReceive")) {
                arr.push(
                    <>
                        <div className='row' style={{marginBottom:'-17px'}}>
                            <div className='col-md-3'>
                                <form>
                                    <div className='form-group'>
                                        <label htmlFor='Amount received'>Amount Received</label>
                                        <input
                                            type="number"
                                            className='form-control'
                                            onClick={(e)=>prevent(e)}
                                            value={item?.amountReceive?item?.amountReceive:''}
                                            onChange={(e) =>handlePaymentDetailsChange("amountReceive", e.target.value, i)}
                                            onWheel={(event)=>event.currentTarget.blur()}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-3'>
                                <form>
                                    <div className='form-group'>
                                        <label htmlFor='Mode of payment'>Mode of Receipt</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            value={item?.modeOfPayment}
                                            onChange={(e) => handlePaymentDetailsChange("modeOfPayment", e.target.value, i)}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-3 ">
                                <div className="form-group">
                                    <div className='date-picker-wraper mr-0'>
                                        <label>Date of Receipt</label>
                                        <Label className='m-0 p-0 w-100'>
                                            <ReactDatePicker
                                                dateFormat="dd-MM-yyyy"
                                                selected={item?.dateOfPayment ? new Date(moment(`${item?.dateOfPayment}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) :null}
                                                onChange={(e: any) => { handlePaymentDetailsChange?.('dateOfPayment', moment(e).format('YYYY-MM-DD'), i) }}
                                                fixedHeight
                                                showMonthDropdown
                                                showYearDropdown
                                                name='dateOfInvoice'
                                                placeholderText='Choose Date'
                                                className='form-control'
                                            />
                                            <span className="calender-icon" style={{ right: '30px', cursor: 'pointer', top: "30px" }}>
                                                <CalenderIcon />
                                            </span>
                                        </Label>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <form>
                                    <Row>
                                        <Col>
                                            <div className='form-group'>
                                                <label htmlFor='Narration'>Narration</label>
                                                <input
                                                    type="text"
                                                    name='narration'
                                                    className='form-control'
                                                    value={item?.narration}
                                                    onChange={(e) => handlePaymentDetailsChange("narration", e.target.value, i)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={1} className="mt-4 p-0">
                                            {paymentDetailsData?.length > 1 ? (
                                                <span className="pointer" onClick={() => handleRemoveRow(i)} >
                                                    <DeleteIcon />
                                                </span>
                                            ) : null}
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </div>
                        <span>{paymentDetailsData?.length > 1 ? (
                            <span>
                                <img className="pointer" src={WhiteDeleteIcon} onClick={() => handleRemoveRow(i)} />
                            </span>
                        ) : null}
                        </span>
                    </>
                )
            }
            if (item?.hasOwnProperty("narration")) {
                arr.push(
                    <span>{paymentDetailsData?.length > 1 ? (
                        <span>
                            <img className="pointer" src={WhiteDeleteIcon} onClick={() => handleRemoveRow(i)} />
                        </span>
                    ) : null}
                    </span>
                )
            }
        })
        return arr;
    }
    return (
        <>{renderPaymentDetails()}</>
    )
}

export default DisbursementPaymentDetails